module.exports = __webpack_public_path__ + "img/jonathan-at-his-wedding.04239e2e.jpg";